var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleMore"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"more",on:{"click":_vm.moreHandler}},[_vm._v(" "+_vm._s(_vm.$t('ViewAll'))+" "),_c('img',{staticClass:"moreico",attrs:{"src":require("../assets/img/newmore@2x.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }